<svelte:options runes={true} />
<script lang="ts">"use strict";
let { max = 10, value = 0 } = $props();
let progress;
let w = $state(0);
let pixelsPerStep = $derived(w / max);
$effect(() => {
    if (progress) {
        progress.style.width = `${pixelsPerStep * value}px`;
    }
});
</script>

<div bind:clientWidth={w} class="progress-container">
  <div bind:this={progress} class="progress"></div>
</div>

<style>
  .progress-container {
    height: 6px;
    background-color: #ffffff;
    width: 100%;
    max-width: 1015px;
    border-radius: 3px;
    overflow: hidden;
    margin: auto auto;
  }

  .progress {
    height: 100%;
    width: 0;
    background-color: #8d5fff;
    transition: width 0.4s ease-in-out;
  }</style>
